module.exports = __webpack_public_path__ + "static/Immuta-3887e1c3ac1769bed9b6489077614f01.jpg";